
const $75d2d73d5e5d9cd8$var$form = document.querySelector(".form");
const $75d2d73d5e5d9cd8$var$submitBtn = document.querySelector(".submit-btn");
const $75d2d73d5e5d9cd8$var$firstName = document.getElementById("first-name");
const $75d2d73d5e5d9cd8$var$firstNameErr = document.getElementById("first-name-err");
const $75d2d73d5e5d9cd8$var$firstErrIcon = document.getElementById("first-error-icon");
const $75d2d73d5e5d9cd8$var$lastName = document.getElementById("last-name");
const $75d2d73d5e5d9cd8$var$lastNameErr = document.getElementById("last-name-err");
const $75d2d73d5e5d9cd8$var$lastErrIcon = document.getElementById("last-error-icon");
const $75d2d73d5e5d9cd8$var$email = document.getElementById("email");
const $75d2d73d5e5d9cd8$var$emailErr = document.getElementById("email-err");
const $75d2d73d5e5d9cd8$var$emailErrIcon = document.getElementById("mail-error-icon");
const $75d2d73d5e5d9cd8$var$password = document.getElementById("password");
const $75d2d73d5e5d9cd8$var$passwordErr = document.getElementById("password-err");
const $75d2d73d5e5d9cd8$var$passwordErrIcon = document.getElementById("password-error-icon");
$75d2d73d5e5d9cd8$var$submitBtn.addEventListener("click", $75d2d73d5e5d9cd8$var$handleSubmit);
$75d2d73d5e5d9cd8$var$form.addEventListener("submit", (e)=>{
    e.preventDefault();
});
function $75d2d73d5e5d9cd8$var$handleSubmit() {
    $75d2d73d5e5d9cd8$var$checkInput();
    $75d2d73d5e5d9cd8$var$checkEmail();
}
function $75d2d73d5e5d9cd8$var$checkInput() {
    if ($75d2d73d5e5d9cd8$var$firstName.value.length == 0) {
        $75d2d73d5e5d9cd8$var$firstNameErr.textContent = "First Name cannot be empty";
        $75d2d73d5e5d9cd8$var$firstName.classList.add("input--invalid");
        $75d2d73d5e5d9cd8$var$firstErrIcon.classList.add("error-icon--shown");
    } else {
        $75d2d73d5e5d9cd8$var$firstNameErr.textContent = "";
        $75d2d73d5e5d9cd8$var$firstName.classList.remove("input--invalid");
        $75d2d73d5e5d9cd8$var$firstErrIcon.classList.remove("error-icon--shown");
    }
    if ($75d2d73d5e5d9cd8$var$lastName.value.length == 0) {
        $75d2d73d5e5d9cd8$var$lastNameErr.textContent = "Last Name cannot be empty";
        $75d2d73d5e5d9cd8$var$lastName.classList.add("input--invalid");
        $75d2d73d5e5d9cd8$var$lastErrIcon.classList.add("error-icon--shown");
    } else {
        $75d2d73d5e5d9cd8$var$lastNameErr.textContent = "";
        $75d2d73d5e5d9cd8$var$lastName.classList.remove("input--invalid");
        $75d2d73d5e5d9cd8$var$lastErrIcon.classList.remove("error-icon--shown");
    }
    if ($75d2d73d5e5d9cd8$var$password.value.length == 0) {
        $75d2d73d5e5d9cd8$var$passwordErr.textContent = "Password cannot be empty";
        $75d2d73d5e5d9cd8$var$password.classList.add("input--invalid");
        $75d2d73d5e5d9cd8$var$passwordErrIcon.classList.add("error-icon--shown");
    } else {
        $75d2d73d5e5d9cd8$var$passwordErr.textContent = "";
        $75d2d73d5e5d9cd8$var$password.classList.remove("input--invalid");
        $75d2d73d5e5d9cd8$var$passwordErrIcon.classList.remove("error-icon--shown");
    }
}
function $75d2d73d5e5d9cd8$var$checkEmail() {
    if ($75d2d73d5e5d9cd8$var$email.validity.typeMismatch) {
        $75d2d73d5e5d9cd8$var$emailErr.textContent = "Looks like this is not an email";
        $75d2d73d5e5d9cd8$var$email.classList.add("input--invalid");
        $75d2d73d5e5d9cd8$var$emailErrIcon.classList.add("error-icon--shown");
    } else if ($75d2d73d5e5d9cd8$var$email.value.length == 0) {
        $75d2d73d5e5d9cd8$var$emailErr.textContent = "Email cannot be empty";
        $75d2d73d5e5d9cd8$var$email.classList.add("input--invalid");
        $75d2d73d5e5d9cd8$var$emailErrIcon.classList.add("error-icon--shown");
    } else {
        $75d2d73d5e5d9cd8$var$emailErr.textContent = "";
        $75d2d73d5e5d9cd8$var$email.classList.remove("input--invalid");
        $75d2d73d5e5d9cd8$var$emailErrIcon.classList.remove("error-icon--shown");
    }
}


console.log("Parcel is working. Hurray!");


//# sourceMappingURL=index.8151952e.js.map
